import * as React from 'react';
import { useNavigate } from 'react-router';
import {
  Grid,
  Typography,
  Paper,
  Stack,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import GetPriorityColor from 'functions/GetPriorityColor';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import { MissingPhoto } from 'Interfaces/IGlobalTypeConfig';
import { useTranslation } from 'react-i18next';
import CustomAvatar from './customAvatar';

export const SingleCompanyView = (props: any) => {
  const { t } = useTranslation();

  let navigate = useNavigate();
  const company = props.company;
  console.log('SingleCompanyView', company);
  return (
    <Tooltip title={company?.name || 'company'} placement='top'>
      <Paper
        //variant='elevation3'

        onClick={() => {}}
        sx={{
          mb: 1,
          display: 'flex',
          flexDirection: 'row',
          borderLeft: 8,
          borderRight: 2,
          borderColor: GetPriorityColor(company?.priority || 0),
          height: 60,
          ':hover': {
            cursor: 'pointer',
            filter: 'brightness(120%)',
            transition: 'all 0.2s ease-in-out',
          },
        }}
      >
        {/* Left Side */}
        <Grid
          item
          sx={{
            maxWidth: 120,
            minWidth: 120,
            height: 60,
            borderTopLeftRadius: '3px',
            borderBottomLeftRadius: '3px',
            display: 'flex',
          }}
        >
          {company?.url ? (
            <Grid
              item
              sx={{
                flexGrow: 1,
                backgroundColor: 'rgba(255, 255, 255, .8)',
                borderRadius: 2,
              }}
            >
              <img
                src={company?.url || MissingPhoto.COMPANY_URL}
                style={{
                  padding: 0,
                  width: 120,
                  height: 60,
                  borderRadius: 10,
                  objectFit: 'contain',
                  backgroundColor: 'primary.text',
                }}
                alt={'previewUrl'}
              />
            </Grid>
          ) : (
            <CustomAvatar avatarName={company?.name || ''} />
          )}
        </Grid>

        {/* Right Side */}

        <Grid
          item
          sx={{
            flexGrow: 1,
            backgroundColor: 'primary.back',
          }}
        >
          <Grid
            container
            direction={'column'}
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            {/* INFO LINE 1*/}
            <Grid
              xs={12}
              item
              sx={{
                width: 'calc(100% - 120px)',
                height: 22,
                borderTopLeftRadius: '3px',
                borderBottomLeftRadius: '3px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{
                  ml: 1,
                  display: 'block',
                  width: 'calc(100% - 160px)',
                  maxWidth: 'calc(100% - 160px)',
                  height: 22,
                  letterSpacing: 1,
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                {company?.name}
              </Typography>

              <Typography
                sx={{
                  ml: 1,

                  pr: 1,
                  height: 22,
                  letterSpacing: 1,
                  textAlign: 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 'normal',
                  fontSize: 14,
                }}
              >
                ( {company?.organizationNumber} )
              </Typography>
              <Box sx={{ width: 34, height: 22, pr: 2, mt: -1 }}>
                {!props?.detailNav && (
                  <IconButton
                    sx={{}}
                    onClick={() => {
                      navigate(`/companies/${company.id}`);
                    }}
                  >
                    <LaunchRoundedIcon sx={{ fontSize: 22 }} />
                  </IconButton>
                )}
              </Box>
            </Grid>

            {/* INFO LINE 2*/}
            <Grid
              xs={12}
              item
              sx={{
                width: 'calc(100% - 120px)',
                height: 22,
                borderTopLeftRadius: '3px',
                borderBottomLeftRadius: '3px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <Typography
                sx={{
                  m: 0,
                  pr: 0.3,
                  pl: 1,
                  fontWeight: 'normal',
                  fontSize: 12,
                }}
              >
                {company?.email || ''}
              </Typography>
            </Grid>

            {/* INFO LINE 3*/}
            <Grid
              xs={12}
              item
              sx={{
                width: 'calc(100% - 120px)',
                height: 22,
                borderTopLeftRadius: '3px',
                borderBottomLeftRadius: '3px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <Grid
                item
                xs={8}
                justifyContent='flex-start'
                alignItems='flex-start'
                sx={{
                  mb: 1,
                  pr: 0.5,
                  pl: 1,
                  display: 'flex',
                }}
              >
                <Typography
                  sx={{
                    mb: 1,
                    pr: 0.3,
                    fontWeight: 'normal',
                    fontSize: 12,
                  }}
                >
                  {company?.webPage || ''}
                </Typography>
              </Grid>

              <Grid
                item
                xs={4}
                justifyContent='flex-end'
                alignItems='flex-end'
                sx={{
                  mb: 1,
                  pr: 0.5,
                  display: 'flex',
                }}
              >
                <Typography
                  sx={{
                    m: 0,
                    pr: 0.3,
                    color: 'secondary.text',
                    fontWeight: 'bold',
                    fontSize: 14,
                    letterSpacing: 2,
                  }}
                >
                  {company?.phone || ''}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Tooltip>
  );
};
